import React from 'react';
import styles from './RadioChip.module.scss';

export interface RadioChipProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  imageUrl: string;
  name: string;
  selected?: boolean;
}

function RadioChip({
  imageUrl,
  name,
  selected = false,
  ...inputProps
}: RadioChipProps): JSX.Element {
  return (
    <>
      <input
        id={`${name}-choice`}
        type="radio"
        hidden
        checked={selected}
        {...inputProps}
      />
      <label
        className={`${styles.choice} ${selected ? styles.selected : ''}`}
        htmlFor={`${name}-choice`}
        data-testid={`${name}-choice`}
      >
        <figure className={styles.choiceImageWrapper}>
          <img src={imageUrl} alt={name} />
        </figure>
        <p>{name}</p>
      </label>
    </>
  );
}

export default RadioChip;
